import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  RadioButtonGroupInput,
  ReferenceInput,
  SelectInput,
  required,
  minLength,
  email,
  BooleanInput,
  FormDataConsumer,
} from 'react-admin'
import { Permission } from '../../components';
import { PERMISSIONS } from '../../constants';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  profiles: {
    width: 220,
  }
}));

const validate = [required()];
const validateEmail = [required(), email()]
const validatePassword = [required(), minLength(6)];

export default (props: any) => {
  const classes = useStyles();
  return (
    <Permission permission={PERMISSIONS.CREATE_SYSTEM_USER}>
      <Create {...props} resource="employees" title="Cadastrar novo usuário" redirect="/system-users">
        <SimpleForm>
          <TextInput source="name" label="Nome" validate={[required()]} InputProps={{ autoComplete: 'off' }} />
          <TextInput source="login" label="Login" validate={validateEmail} InputProps={{ autoComplete: 'off' }} />
          <TextInput source="password" label="Senha" validate={validatePassword} InputProps={{ autoComplete: 'new-password' }} />
          <FormDataConsumer>
            {({ formData }) => (
              <ReferenceInput
                className={classes.profiles}
                source="profileId"
                reference="profiles"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={9999}
                filter={{ type: 'admin' }}
                validate={[required()]} >
                <RadioButtonGroupInput label="Perfil" optionText="name" />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
        </SimpleForm>
      </Create>
    </Permission>
  );
}